import { render, staticRenderFns } from "./J.vue?vue&type=template&id=ac1ce988&scoped=true&"
import script from "./J.vue?vue&type=script&lang=js&"
export * from "./J.vue?vue&type=script&lang=js&"
import style0 from "./J.vue?vue&type=style&index=0&id=ac1ce988&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1ce988",
  null
  
)

export default component.exports